import { render } from "./CategoryOrders.vue?vue&type=template&id=2386bb76"
import script from "./CategoryOrders.vue?vue&type=script&lang=js"
export * from "./CategoryOrders.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__